<template>
  <div>
    <b-card>
      <div class="attachment__container">
        <label class="text__header mb-0">{{ title || "Attachments" }}</label>

        <div class="attachment-list__container">
          <label
            v-if="checkDisableInput() && !attachmentList.length"
            class="text__sub-header"
          >
            No attachment.
          </label>
          <label v-else class="text__sub-header"> Attachment List </label>
          <div v-for="(attachment, index) of attachmentList" :key="index">
            <div class="d-flex justify-content-between align-items-start">
              <div class="mr-2 d-flex flex-column custom-margin-bottom-6">
                <label class="text__title">{{ attachment.name }}</label>
                <label class="text__description">
                  {{ attachment.description }}
                </label>
              </div>
              <div
                v-if="isActionAttachment && hasEditPermission"
                class="custom-margin-bottom-6"
              >
                <feather-icon
                  class="text-secondary icon__pointer"
                  icon="EditIcon"
                  size="20"
                  badge-classes="bg-secondary"
                  @click="clickEditAttachment(attachment)"
                />
                <feather-icon
                  class="text-secondary icon__pointer ml-2"
                  icon="Trash2Icon"
                  size="20"
                  @click="clickDeleteAttachment(attachment)"
                />
              </div>
            </div>

            <div
              v-if="attachment.tags.length !== 0"
              class="d-flex align-items-center custom-margin-bottom-6"
            >
              <feather-icon class="text-secondary" icon="TagIcon" size="16" />
              <div class="d-flex flex-wrap">
                <b-badge
                  v-for="(tag, index) in attachment.tags"
                  :key="index"
                  variant="light-primary"
                  class="tag__space"
                >
                  {{ tag }}
                </b-badge>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <feather-icon
                class="text-secondary"
                icon="FileTextIcon"
                size="16"
              />
              <span
                class="text__file tag__space"
                @click="clickDownloadFile(attachment)"
              >
                {{ attachment.originalFilename || attachment.filename }}
              </span>
            </div>

            <hr />
          </div>
          <div
            v-if="!checkDisableInput() && isActionAttachment"
            class="add-attachment__container"
            @click="clickAddAttachment()"
          >
            <feather-icon
              class="icon-size-24px text-primary"
              icon="PlusCircleIcon"
            ></feather-icon>
            <span class="add-attachment__text">Add Attachment</span>
          </div>
        </div>
      </div>
    </b-card>

    <!-- start modal add attachment -->
    <molecule-modal-dialog
      v-if="isActionAttachment"
      :modalId="'modal-add-attachment' + modalAttachmentId"
      textTitle="Add New Attachment"
      buttonTextLeft="Add"
      buttonTextRight="Cancel"
      buttonColorLeft="primary"
      :isDisableButtonLeft="
        (!addAttachmentForm.name || !addAttachmentForm.name.trim()) || !addAttachmentForm.uploadFile.length
      "
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickAddAttachmentFromModal"
      @clickButtonRight="onClickDiscardAddAttachmentFromModal"
      @clickIconClose="onClickDiscardAddAttachmentFromModal"
    >
      <template #body>
        <div class="w-100 px-30px">
          <atom-input
            v-model="addAttachmentForm.name"
            title="Attachment Title"
            placeholder="Title"
            class="mt-1"
            errorMessage="Please Enter Attachment Title"
            :isAsterisk="true"
            :isError="isCheckError && (!addAttachmentForm.name || !addAttachmentForm.name.trim())"
          ></atom-input>

          <atom-text-area
            v-model="addAttachmentForm.description"
            title="Description"
            placeholder="Description"
            class="mt-1"
          ></atom-text-area>

          <atom-multi-select
            v-model="addAttachmentForm.tags"
            title="Tags"
            :option="tagList"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isPushTaggable="true"
            placeholder="Select Tags"
            class="mt-1"
          ></atom-multi-select>

          <atom-file-attachment-input
            id="uploadAttachmentList"
            title="Attachment"
            subTitle="(Max. 25Mb)"
            :isAsterisk="true"
            :isFlexColumn="true"
            :isError="isCheckError && !addAttachmentForm.uploadFile.length"
            errorMessage="Please Upload Attachment"
            @onUpdateFile="onAddAttachment"
            class="mt-1"
          ></atom-file-attachment-input>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal add attachment -->

    <!-- start modal edit attachment -->
    <molecule-modal-dialog
      v-if="isActionAttachment"
      :modalId="'modal-edit-attachment' + modalAttachmentId"
      textTitle="Edit Attachment"
      buttonTextLeft="Save Changes"
      buttonTextRight="Cancel"
      buttonColorLeft="primary"
      :isDisableButtonLeft="
        !isTargetAttachmentChange || (!editAttachmentForm.name || !editAttachmentForm.name.trim())
      "
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickUpdateAttachmentFromModal"
      @clickButtonRight="onClickDiscardEditAttachmentFromModal"
      @clickIconClose="onClickDiscardEditAttachmentFromModal"
    >
      <template #body>
        <div class="w-100 px-30px">
          <atom-input
            v-model="editAttachmentForm.name"
            title="Attachment Title"
            placeholder="Title"
            class="mt-1"
            errorMessage="Please Enter Attachment Title"
            :isAsterisk="true"
            :isError="isCheckError && (!editAttachmentForm.name || !editAttachmentForm.name.trim())"
          ></atom-input>

          <atom-text-area
            v-model="editAttachmentForm.description"
            title="Description"
            placeholder="Description"
            class="mt-1"
          ></atom-text-area>

          <atom-multi-select
            v-model="editAttachmentForm.tags"
            title="Tags"
            :option="tagList"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isPushTaggable="true"
            placeholder="Select Tags"
            class="mt-1"
          ></atom-multi-select>

          <div class="mt-1">
            <div class="mb-8px">
              <span class="file__title">Attachment</span>
              <span class="file__asterisk">*</span>
              <span class="file__title ml-1">(Max. 25Mb)</span>
            </div>
            <span
              class="text__file"
              @click="clickDownloadFile(editAttachmentForm.file)"
            >
              {{
                editAttachmentForm.originalFilename ||
                editAttachmentForm.filename
              }}
            </span>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>

    <!-- end modal edit attachment -->

    <!-- start modal has change -->
    <molecule-modal-dialog
      :modalId="'modal-has-change-before-update-attachment' + modalAttachmentId"
      textTitle="Do you want to save changes before ?"
      :textSubtitle="`There are some contract detail changes\nit will be discard after update attachment data`"
      buttonTextLeft="Save Changes"
      buttonTextRight="Update Attachment"
      :isTextCenter="true"
      @clickButtonLeft="onClickSaveChangeBeforeUpdateAttachment"
      @clickButtonRight="onClickUpdateAttachmentWithoutSaveChanges"
      @clickIconClose="closeModal()"
    >
    </molecule-modal-dialog>
    <!-- end modal has change -->

    <!-- start modal confirm save changes attachment -->
    <molecule-modal-dialog
      :modalId="'modal-confirm-save-change' + modalAttachmentId"
      :textTitle="`Do you want to save changes\n“${editAttachmentForm.name}” ?`"
      buttonTextLeft="Save Changes"
      :isTextCenter="true"
      @clickButtonLeft="onClickConfirmUpdateAttachmentFromModal"
      @clickButtonRight="openModal('modal-edit-attachment' + modalAttachmentId)"
      @clickIconClose="openModal('modal-edit-attachment' + modalAttachmentId)"
    >
    </molecule-modal-dialog>
    <!-- end modal confirm save changes attachment -->

    <!-- start modal confirm discard attachment -->
    <molecule-modal-dialog
      :modalId="'modal-confirm-discard-change-attachment-' + modalAttachmentId"
      :isTextCenter="true"
      textTitle="Do you want to leave without finishing?"
      buttonTextLeft="Confirm"
      @clickButtonLeft="onClickConfirmDiscardEditAttachmentFromModal"
      @clickButtonRight="openModal('modal-edit-attachment' + modalAttachmentId)"
    >
    </molecule-modal-dialog>
    <!-- end modal confirm discard attachment -->

    <!-- start modal delete access-->
    <molecule-modal-dialog
      v-if="isActionAttachment"
      v-for="(attachment, index) in attachmentList"
      :key="index"
      :modalId="
        `${attachment.id}modal-confirm-delete-attachment` + modalAttachmentId
      "
      icon="AlertCircleIcon"
      :textTitle="`Do you want to delete\n“${targetFile.filename}” ?`"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      :isTextCenter="true"
      @clickButtonLeft="onClickConfirmDeleteAttachmentFromModal"
    >
    </molecule-modal-dialog>
    <!-- end modal delete access -->
  </div>
</template>

<script>
import { BCard, BBadge } from "bootstrap-vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixins from "@/mixins"

export default {
  name: "MoleculeAttachmentList",
  components: {
    BCard,
    BBadge,
    AtomInput,
    MoleculeModalDialog,
    AtomTextArea,
    AtomMultiSelect,
    AtomFileAttachmentInput,
  },
  mixins: [mixins, mixinsObjectHelper],
  emits: [
    "onRequestSaveChangesContract",
    "onRequestAddAttachment",
    "onRequestEditAttachment",
    "onRequestDeleteAttachment",
  ],
  props: {
    hasChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    isErrorOccur: {
      type: Boolean,
      required: false,
      default: false,
    },
    attachmentList: {
      type: Array,
      required: false,
      default: () => [],
    },
    tagList: {
      type: Array,
      required: false,
      default: () => [],
      // example: ["Tag1"],
    },
    contractStatus: {
      type: String,
      required: false,
      default: "",
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    requestStatus: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    modalAttachmentId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      modalId: null,
      nextModalId: null,
      targetFile: {
        filename: "",
        fileUrl: "",
      },
      isAddAttachment: true,
      isCheckError: false,
      addAttachmentForm: {
        id: "",
        name: "",
        description: "",
        type: "",
        tags: [],
        uploadFile: [],
      },
      originEditAttachmentForm: {
        id: "",
        name: "",
        description: "",
        tags: [],
        filename: "",
        fileUrl: "",
      },
      editAttachmentForm: {
        id: "",
        name: "",
        description: "",
        tags: [],
        filename: "",
        fileUrl: "",
      },
    }
  },
  computed: {
    isInternalAccess() {
      return this.$route.meta.type === "internal"
    },

    isErrorAtAddAttachment() {
      return this.isCheckError
        ? !this.addAttachmentForm.name ||
            !this.addAttachmentForm?.uploadFile?.length
        : false
    },
    isErrorAtEditAttachment() {
      return this.isCheckError
        ? !this.editAttachmentForm.name ||
            !this.editAttachmentForm?.fileName ||
            !this.editAttachmentForm?.fileUrl
        : false
    },
    isTargetAttachmentChange() {
      return this.compareIsChangeObject(
        this.editAttachmentForm,
        this.originEditAttachmentForm
      )
    },
    isContractInDeletedStatus() {
      return this.contractStatus?.toLowerCase() === "deleted"
    },
    isActionAttachment() {
      return (
        !["CLOSED", "REJECTED"].includes(this.requestStatus) ||
        this.isInternalAccess
      )
    },
  },
  methods: {
    async clickDownloadFile(file) {
      try {
        const fileUrl = file.filePath || file.fileUrl
        if (!fileUrl) throw error
        const response = await fetch(fileUrl)
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        const filename = file.originalFilename || file.filename
        link.href = url
        link.download = filename
        link.click()
        URL.revokeObjectURL(url)
        this.toastSuccess("Download File Successfully")
      } catch (error) {
        this.toastError("Download File Failed")
      }
    },

    onAddAttachment(fileList) {
      this.addAttachmentForm.uploadFile = fileList
    },

    clickAddAttachment() {
      this.setDefaultAddAttachmentForm()
      this.nextModalId = "modal-add-attachment" + this.modalAttachmentId
      if (this.hasChange) {
        this.openModal("modal-has-change-before-update-attachment" + this.modalAttachmentId)
      } else {
        this.showAddAttachmentModal()
      }
    },

    onClickSaveChangeBeforeUpdateAttachment() {
      this.$emit("onRequestSaveChangesContract")

      if (this.isErrorOccur) {
        this.closeModal()
      }
      this.isErrorOccur ? this.closeModal() : this.openNextModal()
    },

    onClickUpdateAttachmentWithoutSaveChanges() {
      this.openNextModal()
    },

    openNextModal() {
      if (this.nextModalId.includes("modal-confirm-delete-attachment")) {
        this.openModal(this.nextModalId)
      } else if (
        this.nextModalId ===
        "modal-add-attachment" + this.modalAttachmentId
      ) {
        this.showAddAttachmentModal()
      } else {
        this.showEditAttachmentModal()
      }
    },

    showAddAttachmentModal() {
      this.openModal("modal-add-attachment" + this.modalAttachmentId)
    },

    onClickAddAttachmentFromModal() {
      this.isCheckError = true
      this.$nextTick(() => {
        if (!this.isErrorAtAddAttachment) {
          if (this.modalAttachmentId === "modal-attachment-internal") {
            this.addAttachmentForm.type = "INTERNAL"
          } else if (this.modalAttachmentId === "modal-attachment-external") {
            this.addAttachmentForm.type = "EXTERNAL"
          }
          this.$emit("onRequestAddAttachment", this.addAttachmentForm)
          this.closeModal()
        }
      })
    },

    onClickDiscardAddAttachmentFromModal() {
      this.closeModal()
      this.setDefaultAddAttachmentForm()
    },

    setDefaultAddAttachmentForm() {
      this.isCheckError = false
      this.addAttachmentForm = {
        id: "",
        name: "",
        description: "",
        tags: [],
        uploadFile: [],
      }
    },

    clickEditAttachment(attachment) {
      this.nextModalId = "modal-edit-attachment" + this.modalAttachmentId
      if (this.hasChange) {
        this.openModal("modal-has-change-before-update-attachment" + this.modalAttachmentId)
      } else {
        this.showEditAttachmentModal(attachment)
      }
    },

    showEditAttachmentModal(attachment) {
      this.openModal("modal-edit-attachment" + this.modalAttachmentId)
      this.originEditAttachmentForm = this.deepCopyObject(attachment)
      this.editAttachmentForm = this.deepCopyObject(attachment)
    },

    onClickUpdateAttachmentFromModal() {
      this.isCheckError = true
      this.openModal("modal-confirm-save-change" + this.modalAttachmentId)
    },

    onClickConfirmUpdateAttachmentFromModal() {
      if (!this.isErrorEditAttachment) {
        this.$emit("onRequestEditAttachment", this.editAttachmentForm)
        this.closeModal()
        this.setDefaultEditAttachmentForm()
      }
    },

    onClickDiscardEditAttachmentFromModal() {
      if (this.isTargetAttachmentChange) {
        this.openModal(
          "modal-confirm-discard-change-attachment" + this.modalAttachmentId
        )
      } else {
        this.closeModal()
        this.setDefaultEditAttachmentForm()
      }
    },

    onClickConfirmDiscardEditAttachmentFromModal() {
      this.setDefaultEditAttachmentForm()
      this.closeModal()
    },

    setDefaultEditAttachmentForm() {
      this.isCheckError = false
      const defaultValue = {
        id: "",
        name: "",
        description: "",
        tags: [],
        filename: "",
        fileUrl: "",
      }
      this.editAttachmentForm = this.deepCopyObject(defaultValue)
      this.originEditAttachmentForm = this.deepCopyObject(defaultValue)
    },

    clickDeleteAttachment(attachment) {
      if (this.hasChange) {
        this.nextModalId = `${attachment.id}modal-confirm-delete-attachment` +
            this.modalAttachmentId
        this.openModal(this.openModal("modal-has-change-before-update-attachment" + this.modalAttachmentId))
      } else {
        this.openModal(
          `${attachment.id}modal-confirm-delete-attachment` +
            this.modalAttachmentId
        )
      }

      this.targetFile = attachment
    },

    onClickConfirmDeleteAttachmentFromModal() {
      this.$emit("onRequestDeleteAttachment", this.targetFile)
      this.closeModal()
      this.targetFile = {
        filename: "",
        fileUrl: "",
      }
    },

    openModal(modalId) {
      if (this.modalId) this.closeModal()
      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    checkDisableInput(condition = false) {
      const booleanCondition = Boolean(condition)
      return (
        !this.hasEditPermission ||
        this.isContractInDeletedStatus ||
        booleanCondition
      )
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.attachment__container {
  width: 100%;
  max-width: 550px;
}

.attachment-list__container {
  margin-top: 27px;
}

.text__header {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.text__sub-header {
  color: #5e5873;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 18px;
}

.text__title {
  color: #82868b;
  font-weight: 600;
  font-size: 14px;
}

.text__description {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
}

.text__file {
  cursor: pointer;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  background: #eeedfd;
  align-items: center;
  padding: 0.3rem 9px;
  border-radius: 4px;
  text-decoration-line: underline;

  &:hover {
    background: #dfddff;
    color: #584cdb;
  }
}

.tag__space {
  margin-left: 5px;
  margin-bottom: 5px;
}

.icon__pointer {
  cursor: pointer;

  &:hover {
    color: #6e6b7b !important;
  }
}

.add-attachment__container {
  margin: 10px 0 1rem 0;
  padding: 1rem;
  width: 100%;
  background: #ffffff;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: #f9f9fe;
  }
}

.add-attachment__text {
  margin-left: 10px;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.px-30px {
  padding-left: 30px;
  padding-right: 30px;
}

.mb-8px {
  margin-bottom: 8px;
}

.file__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.file__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}
</style>
